module.exports = __webpack_public_path__ + "img/PENDING_RED.e323eb90.svg";